import api from '../../../services/Api';
import { IAuditoriaOutrasDespesasResultado } from '../interfaces/IAuditoriaOutrasDespesas';

export const AuditoriaOutrasDespesasService = {
  buscarResultado: async (params: { empresaId: number; periodo: string | undefined })
    : Promise<IAuditoriaOutrasDespesasResultado> => {
    const response = await api.get<IAuditoriaOutrasDespesasResultado>(
      'auditoria-outras-despesas/resultado',
      { params: { empresaIds: params.empresaId, periodo: params.periodo } }
    );
    return response.data;
  },
};
